import styled, { css } from "styled-components";
import { InputComponent } from "../common/InputComponent";
import CustomButton from "../common/customButton";
import { useState } from "react";
import CloseIcon from "../icon/closeIcon";
import MoveDateInputComponent from "../detail/MoveDateInputComponent";
import CustomInputComponent from "../common/customInputComponent";
import PencilIcon from "../icon/pencil";
import API from "../../API/API";
import AdminMoveDateInputComponent from "./adminMoveDateInputComponent";
import AdminCustomInputComponent from "./adminCustomInputComponent";

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2); /* 배경을 약간 어둡게 만듭니다. */
  z-index: 9998; /* 모달보다 아래에 위치하도록 설정합니다. */
`;

const Wrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40vw;
  height: 80vh;
  background-color: white;
  border-radius: 0.8vw;
`;

const ModalWrapper = styled.div`
  width: 84%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;

const ModalTopArea = styled.div`
  margin-top: 1vw;
  margin-bottom: 1vw;
  width: 100%;
  height: 12vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const HeaderText = styled.div`
  display: flex;
  justify-content: start;
  align-items: end;
`;
const HeaderNameText = styled.div`
  font-size: 1.7vw;
  font-weight: 700;
  color: #ff7f3b;
`;
const HeaderInfoText = styled.div`
  font-size: 1.6vw;
  font-weight: 700;
`;
const DateWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
const ContentsWrapper = styled.div`
  width: 100%;
  height: 40vw;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;
const CloseBtnBox = styled.div`
  width: 3vw;
  height: 3vw;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.5vw;
  background-color: #8080802f;
`;

const BtnBox = styled.div`
  margin-top: 1vw;
  margin-bottom: 3vw;
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* outline: 1px solid red; */
`;

export default function AdminCreatePopUpModal(props: any) {
  const { onClose } = props;

  const [expireAt, setExpireAt] = useState<String | null>("");
  const [applyAt, setApplyAt] = useState<String | null>("");
  const [title, setTitle] = useState<string | undefined>();
  const [content, setContent] = useState<string | undefined>();

  //----- 공지사항 제목
  const onChangeTitleInput = (e: any) => {
    setTitle(e.target.value);
  };

  //----- 공지사항 내용
  const onChangeTitleContent = (e: any) => {
    setContent(e.target.value);
  };
  const formattedDate = /^(\d{4})(\d{2})(\d{2})$/;
  //----- 완료
  const onSubmit = async () => {
    try {
      const requestParam = {
        expireAt: expireAt?.replace(formattedDate, "$1-$2-$3"),
        applyAt: applyAt?.replace(formattedDate, "$1-$2-$3"),
        title: title,
        content: content,
      };
      const response = await API.post("notice", requestParam);

      onClose();
    } catch (error) {
      alert(error);
    }
  };

  return (
    <>
      <Backdrop />
      <Wrapper style={{ transform: "translate(1.2)" }}>
        <ModalWrapper>
          <ModalTopArea>
            <HeaderText>
              <HeaderNameText>
                <PencilIcon
                  width={"1.7vw"}
                  height={"1.7vw"}
                  fill={"#ff7f3b"}
                ></PencilIcon>
              </HeaderNameText>
              <HeaderInfoText>&nbsp;{"공지사항 추가"}</HeaderInfoText>
            </HeaderText>

            <CloseBtnBox>
              <CloseIcon onClick={onClose} height={"1.6vw"} fill={"#969696"} />
            </CloseBtnBox>
          </ModalTopArea>
          <DateWrapper>
            <AdminMoveDateInputComponent
              title={"시작날짜"}
              dateData={applyAt}
              setDateData={setApplyAt}
            ></AdminMoveDateInputComponent>
            <AdminMoveDateInputComponent
              title={"만료날짜"}
              dateData={expireAt}
              setDateData={setExpireAt}
            ></AdminMoveDateInputComponent>
          </DateWrapper>
          <ContentsWrapper>
            <AdminCustomInputComponent
              width={"33vw"}
              height={"6vh"}
              label={"제목"}
              $fontSize={"1vw"}
              isRequired={true}
              placeholder={"제목을 입력해 주세요"}
              value={title}
              onChangeInput={onChangeTitleInput}
            ></AdminCustomInputComponent>
            <AdminCustomInputComponent
              width={"33vw"}
              height={"30vh"}
              label={"내용"}
              $fontSize={"1vw"}
              isRequired={true}
              isTextArea={true}
              placeholder={"내용을 입력해 주세요"}
              value={content}
              onChangeInput={onChangeTitleContent}
            ></AdminCustomInputComponent>
          </ContentsWrapper>
          <BtnBox>
            <CustomButton
              width={"33vw"}
              height={"6vh"}
              text={`확인`}
              size={"1.6vw"}
              radius={"0.4vw"}
              onClick={onSubmit}
            ></CustomButton>
          </BtnBox>
        </ModalWrapper>
      </Wrapper>
    </>
  );
}
